export function ComingSoonBadge({ className = "" }) {
  return (
    <div className={`coming-soon-ribbon inline-flex items-center gap-1.5 rounded-full bg-[#00F0FF]/10 border border-[#00F0FF]/30 px-2.5 py-1 text-[10px] font-bold uppercase text-[#00F0FF] ${className}`} data-testid="coming-soon-badge">
      <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF] animate-pulse" />
      Coming Soon
    </div>
  );
}

export function ComingSoonOverlay() {
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-t from-[#08090E]/80 via-transparent to-transparent" />
      <span className="coming-soon-ribbon rotate-[-4deg] rounded-md bg-[#08090E]/70 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#00F0FF] backdrop-blur-sm border border-[#00F0FF]/40">
        Coming Soon
      </span>
    </div>
  );
}
